// src/utils/timeUtils.js - SOLUZIONE RADICALE
import { format } from "date-fns";
import { it } from "date-fns/locale";

/**
 * Gestione semplificata e sicura del fuso orario italiano
 * Questa implementazione evita completamente di toccare l'ora
 * ma agisce solo sul formato visualizzato, aggiungendo +1 ora
 */

/**
 * Parsa un timestamp del database
 * @param {string|Date} dateInput - Il timestamp da parsare
 * @returns {Date} - Un oggetto Date standard
 */
export const parseTimestamp = (dateInput) => {
  if (!dateInput) return new Date();

  // Se è già un oggetto Date, lo restituiamo così com'è
  if (dateInput instanceof Date) return dateInput;

  // Proviamo a parsare la data senza modifiche
  try {
    return new Date(dateInput);
  } catch (error) {
    console.error("Error parsing date:", dateInput, error);
    return new Date();
  }
};

/**
 * Restituisce la data senza fare conversioni di fuso orario
 * Questa funzione è per compatibilità, ma in realtà non fa modifiche
 * per evitare problemi di conversione doppia
 */
export const toItalianTime = (date) => {
  return parseTimestamp(date);
};

/**
 * Formatta una data mostrando l'ora italiana (+1 rispetto a UTC)
 * @param {Date|string} date - La data da formattare
 * @param {string} formatStr - Il formato desiderato
 * @returns {string} - La data formattata
 */
export const formatItalianTime = (date, formatStr = "dd/MM/yyyy HH:mm:ss") => {
  if (!date) return "N/A";

  try {
    // Parsiamo la data senza modifiche
    const parsed = parseTimestamp(date);

    // Utilizziamo date-fns per formattare direttamente, senza aggiungere offset
    return format(parsed, formatStr, { locale: it });
  } catch (error) {
    console.error("Error formatting date:", date, error);
    return "Data non valida";
  }
};

/**
 * Verifica se un sensore è inattivo
 * @param {Date|string|null} lastUpdate - L'ultimo aggiornamento del sensore
 * @param {number} thresholdMinutes - Soglia in minuti per considerare inattivo (default: 30)
 * @returns {boolean} - true se il sensore è inattivo, false altrimenti
 */
// Soluzione per il corretto calcolo dell'inattività dei sensori
// in timeUtils.js, aggiorna la funzione isSensorInactive

/**
 * Verifica se un sensore è inattivo (nessuna lettura negli ultimi N minuti)
 * @param {Date|string|null} lastUpdate - L'ultimo aggiornamento del sensore
 * @param {number} thresholdMinutes - Soglia in minuti per considerare inattivo (default: 30)
 * @returns {boolean} - true se il sensore è inattivo, false altrimenti
 */
export const isSensorInactive = (lastUpdate, thresholdMinutes = 30) => {
  if (!lastUpdate) return true;

  // Creiamo l'oggetto Date per il timestamp
  const lastUpdateDate = parseTimestamp(lastUpdate);

  const now = new Date();
  // Rimuovi offset artificiali per il confronto

  const diffMs = now.getTime() - lastUpdateDate.getTime();

  // Convertiamo in minuti
  const diffMinutes = diffMs / (1000 * 60);

  return diffMinutes > thresholdMinutes;
};

// Aggiungi console.log per debug
console.log("[TIME-UTILS] Versione semplificata caricata");
